export class AESEncryptionDecryption
 {
    static decryptWithAES(plaintext: any, key: string): string 
    {
        var CryptoJS = require("crypto-js");

        let decrypted = CryptoJS.enc.Base64.parse(plaintext).toString(CryptoJS.enc.Utf8);
        let bytes = CryptoJS.AES.decrypt(decrypted, key).toString(CryptoJS.enc.Utf8);

        console.log("Decrypted Data: " + bytes);

        return bytes;
    }

    static decryptWithAESSha1(plaintext: string, key: string): string 
    {
        var CryptoJS = require("crypto-js");
        
        var result = CryptoJS.AES.decrypt(plaintext, CryptoJS.enc.Base64.parse(key),
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }
        );
        return decodeURIComponent(result.toString(CryptoJS.enc.Utf8));
    }

    static encryptWithAES(plaintext: string, key: string): string 
    {
        var CryptoJS = require("crypto-js");

        var ciphertext = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(
            CryptoJS.AES.encrypt(plaintext, key).toString()));

        console.log("Encrypted Data: " + ciphertext);

        return ciphertext;
    }
}  



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/aseencryption.tsx